// extracted by mini-css-extract-plugin
export default {"logo-orange":"logo_logo-orange__ksGme","logo-white":"logo_logo-white__atlNX"};